﻿import { DateTime } from 'luxon'
window.DateTime = DateTime;
import { TabulatorFull as Tabulator } from 'tabulator-tables';

export const tabulator = {
  init: function (selector, token, options) {
	options = { ...tabulator.defaultOptions, ...options }
	options.ajaxConfig.headers['RequestVerificationToken'] = token;
	return new Tabulator(selector, options);
  },
  handle: function (cell, formatterParams, onRendered) {
	let container = document.createElement('div');

	let sequence = document.createElement('span');
	sequence.innerText = cell.getValue();
	sequence.className = 'text-sm font-600';
	container.appendChild(sequence);

	let icon = document.createElement('i');
	icon.className = 'i-ic-round-drag-handle text-lg';
	icon.title = 'Sposta';
	container.appendChild(icon);

	return container.innerHTML;
  },
  svg: function (cell, formatterParams, onRendered) {
	let container = document.createElement('div');

	let svg = document.createElement('div');
	svg.className = 'w-12';
	svg.innerHTML = cell.getValue();

	container.appendChild(svg);

	return container.innerHTML;
  },
  fileUrls: function (cell, formatterParams, onRendered) {
	let data = cell.getValue();
	let buttons;
	if (data.length > 0) {
	  buttons = data
		.map(x => {
		  let container = document.createElement('div');
		  container.classList = "flex items-center gap-1";

		  let copyBtn = document.createElement('button');
		  copyBtn.type = 'button';
		  copyBtn.classList = 'btn btn-sm btn-outline-yellow';
		  copyBtn.onclick = 'navigator.clipboard.writeText("${ x }")';
		  container.appendChild(copyBtn);

		  let copyIcon = document.createElement('i');
		  copyIcon.className = 'i-ic-outline-file-copy';
		  copyIcon.title = 'Copia Link';
		  copyBtn.appendChild(copyIcon);

		  let showLink = document.createElement('a');
		  showLink.href = x;
		  showLink.target = '_blank';
		  showLink.classList = 'btn btn-sm btn-outline-teal';
		  container.appendChild(showLink);

		  let linkIcon = document.createElement('i');
		  linkIcon.className = 'i-tabler-external-link';
		  linkIcon.title = 'Vedi Immgine';
		  showLink.appendChild(linkIcon);

		  let span = document.createElement('span')
		  span.innerText = `${x.split('-').pop().split('.').shift()}px`;
		  container.appendChild(span);

		  return container.outerHTML;
		})
		.join('');
	} else {
	  let row = cell.getRow().getData();
	  
	  let container = document.createElement('div');
	  container.classList = "flex items-center gap-1";

	  let copyBtn = document.createElement('button');
	  copyBtn.type = 'button';
	  copyBtn.classList = 'btn btn-sm btn-outline-yellow';
	  copyBtn.onclick = 'navigator.clipboard.writeText("${ x }")';
	  container.appendChild(copyBtn);

	  let copyIcon = document.createElement('i');
	  copyIcon.className = 'i-ic-outline-file-copy';
	  copyIcon.title = 'Copia Link';
	  copyBtn.appendChild(copyIcon);

	  let showLink = document.createElement('a');
	  showLink.href = row.sourceUrl;
	  showLink.target = '_blank';
	  showLink.classList = 'btn btn-sm btn-outline-teal';
	  container.appendChild(showLink);

	  let linkIcon = document.createElement('i');
	  linkIcon.className = 'i-tabler-external-link';
	  linkIcon.title = 'Vedi Immgine';
	  showLink.appendChild(linkIcon);

	  let span = document.createElement('span')
	  span.innerText = `source`;
	  container.appendChild(span);

	  buttons = container.outerHTML;
	}
	return `<div class="flex flex-col w-full items-start gap-1">${buttons}</div>`;
  },
  isPublic: function (cell, formatterParams, onRendered) {
	let data = cell.getData();
	let container = document.createElement('div');
	container.className = 'flex flex-col items-center';
	let icon = document.createElement('i');
	if (data.isPublic) {
	  icon.className = 'i-ic-round-check text-green-500';
	  icon.title = 'Pubblico';
	} else {
	  icon.className = 'i-ic-round-close text-red-500';
	  icon.title = 'NON Pubblico';
	}
	container.appendChild(icon);

	if (data.startDate !== null) {
	  let startDate = document.createElement('small');
	  let date = new Date(data.startDate)
	  startDate.innerHTML = `Dal ${date.toLocaleDateString('it')}`;
	  container.appendChild(startDate);
	}
	if (data.endDate !== null) {
	  let endDate = document.createElement('small');
	  let date = new Date(data.endDate)
	  endDate.innerHTML = `Al ${date.toLocaleDateString('it')}`;
	  container.appendChild(endDate);
	}

	return container.outerHTML;
  },
  list: function (cell, formatterParams, onRendered) {
	let values = cell.getValue();
	let result = '';
	values.forEach((value) => {
	  formatterParams.fields.forEach((field) => {
		result += `${value[field]} `;
	  });
	  result = `${result.trim()}, `;
	});

	return result.slice(0, -2);
  },
  date: function (cell, formatterParams, onRendered) {
	let value = cell.getValue();
	return new Date(value).toLocaleDateString('it-IT');
  },
  datetime: function (cell, formatterParams, onRendered) {
	let value = cell.getValue();
	let date = new Date(value);
	return `${date.toLocaleDateString('it-IT')}<br/>${date.toLocaleTimeString('it-IT')}`;
  },
  colored: function (cell, formatterParams, onRendered) {
	let value = cell.getValue();
	let element = cell.getElement();
	element.style.color = value.color;
	return value.name;
  },
  bgColored: function (cell, formatterParams, onRendered) {
	let value = cell.getValue();
	let element = cell.getElement();
	element.style.backgroundColor = value.color;
	element.style.color = '#ffffff';
	return value.name;
  },
  customButton: function (cell, formatterParams, onRendered) {
	cell.getElement().classList.add("action-column");
	let dataObject = {};
	dataObject[cell._cell.column.field] = cell._cell.value;
	let href = tabulator.replaceMe(formatterParams.url, dataObject);
	if (formatterParams.isBlank) {
	  return `
<a class="${formatterParams.css}" href="${href}" target="_blank">
    ${formatterParams.text}
</a>`;
	} else {
	  return `
<a class="${formatterParams.css}" href="${href}">
    ${formatterParams.text}
</a>`;
	}
  },
  editButton: function (cell, formatterParams, onRendered) {
	let defaultParams = {
	  text: '<i class="i-iconamoon-edit-light" title="Modifica"></i>',
	  css: 'btn btn-action btn-outline-blue'
	}
	return tabulator.customButton(cell, { ...defaultParams, ...formatterParams }, onRendered);
  },
  deleteButton: function (cell, formatterParams, onRendered) {
	let defaultParams = {
	  text: '<i class="i-ph-trash-light" title="Elimina"></i>',
	  css: 'btn btn-action btn-outline-red'
	}
	return tabulator.customButton(cell, { ...defaultParams, ...formatterParams }, onRendered);
  },
  detailsButton: function (cell, formatterParams, onRendered) {
	let defaultParams = {
	  text: '<i class="i-carbon-search" title="Dettagli"></i>',
	  css: 'btn btn-action btn-outline-yellow'
	}
	return tabulator.customButton(cell, { ...defaultParams, ...formatterParams }, onRendered);
  },
  printButton: function (cell, formatterParams, onRendered) {
	let defaultParams = {
	  text: '<i class="i-material-symbols-print-outline" title="Stampa"></i>',
	  css: 'btn btn-action btn-purple',
	  isBlank: true,
	}
	return tabulator.customButton(cell, { ...defaultParams, ...formatterParams }, onRendered);
  },
  optionsButton: function (cell, formatterParams, onRendered) {
	let defaultParams = {
	  text: '<i class="i-mingcute-settings-2-line" title="Opzioni"></i>',
	  css: 'btn btn-action btn-purple'
	}
	return tabulator.customButton(cell, { ...defaultParams, ...formatterParams }, onRendered);
  },
  moveRow: function (fromIndex, toIndex, options, token) {
	let data = new FormData();
	data.append('elementType', options.elementType);
	if (options.elementId) {
	  data.append('elementId', options.elementId);
	}
	data.append('origin', fromIndex);
	data.append('target', toIndex);

	return fetch(`/api/sortable/sort`, {
	  method: 'POST',
	  headers: { 'RequestVerificationToken': token },
	  body: new URLSearchParams(data)
	})
	  .then(response => response.text())
	  .catch((errors) => { console.error(errors); });
  },
  replaceMe: function (template, data) {
	template = decodeURI(template);
	const pattern = /{\s*(\w+?)\s*}/g;
	return template.replace(pattern, (_, token) => data[token] || '');
  },
  defaultOptions: {
	locale: 'it',
	langs: {
	  'it': {
		'data': {
		  'loading': 'Caricamento...',
		  'error': 'Errore',
		},
		'groups': {
		  'item': 'elemento',
		  'items': 'elementi',
		},
		'pagination': {
		  'page_size': 'Visualizza',
		  'page_title': 'Elementi per pagina',
		  'first': '«',
		  'first_title': 'Prima pagina',
		  'last': '»',
		  'last_title': 'Ultima pagina',
		  'prev': '‹',
		  'prev_title': 'Pagina precedente',
		  'next': '›',
		  'next_title': 'Pagina successiva',
		  'all': 'All'
		},
		'headerFilters': {
		  'default': 'Filtra...'
		}
	  }
	},
	columnDefaults: {
	  vertAlign: 'middle',
	  resizable: 'header',
	},
	resizableRows: false,
	selectable: false,
	layout: 'fitColumns',
	responsiveLayout: 'hide',
	ajaxConfig: {
	  method: 'POST',
	  headers: {}
	},
	filterMode: 'remote',
	sortMode: 'remote',
	pagination: true,
	paginationMode: 'remote',
	paginationSize: 20,
	paginationSizeSelector: [10, 20, 50],
	persistence: {
	  sort: false,
	  filter: true,
	  headerFilter: true,
	  group: false,
	  page: false,
	  columns: false,
	},
	footerElement: '<div class="elements"></div >',
	ajaxResponse: function (url, params, response) {
	  let filtered = response.filtered_records ?? 0;
	  let total = response.total_records ?? 0;
	  if (filtered != total) {
		document.querySelector('.elements').innerHTML = `Elementi: ${filtered} filtrati da ${total}`;

	  } else {
		document.querySelector('.elements').innerHTML = `Elementi: ${total}`;
	  }
	  return response;
	},
  }
}